/**
 * Catalog collection: hover image swap + color swatch main image (featured-products-grid parity).
 */
(function () {
  function isDesktopGallery() {
    return window.innerWidth > 999;
  }

  function bindGalleryHovers(root) {
    root.querySelectorAll('.product-gallery-wrapper').forEach(function (wrapper) {
      if (wrapper.dataset.pgfGalleryBound === '1') return;
      wrapper.dataset.pgfGalleryBound = '1';

      const mediaItems = wrapper.querySelectorAll('.product-media-item');
      if (mediaItems.length <= 1) return;

      let hoverTimeout;

      wrapper.addEventListener('mouseenter', function () {
        if (!isDesktopGallery()) return;
        clearTimeout(hoverTimeout);
        mediaItems.forEach((item) => item.classList.remove('product-media-item--active'));
        if (mediaItems[1]) mediaItems[1].classList.add('product-media-item--active');
      });

      wrapper.addEventListener('mouseleave', function () {
        if (!isDesktopGallery()) return;
        clearTimeout(hoverTimeout);
        hoverTimeout = setTimeout(function () {
          mediaItems.forEach((item) => item.classList.remove('product-media-item--active'));
          if (mediaItems[0]) mediaItems[0].classList.add('product-media-item--active');
        }, 100);
      });
    });
  }

  function updateProductImages(blockId, variantId, clickedSwatch, variantImage) {
    if (!clickedSwatch || !variantImage) return;
    const productContainer = clickedSwatch.closest('.product-series-item');
    if (!productContainer) return;
    const galleryWrapper = productContainer.querySelector('.product-gallery-wrapper');
    if (!galleryWrapper) return;
    const allMediaItems = galleryWrapper.querySelectorAll('.product-media-item');
    if (allMediaItems.length === 0) return;
    const mainImageItem = allMediaItems[0];
    const mainImage = mainImageItem.querySelector('img');
    if (mainImage && variantImage) {
      mainImage.src = variantImage;
      mainImage.removeAttribute('srcset');
      mainImage.setAttribute('sizes', '(min-width: 1400px) 560px, (min-width: 1000px) 45vw, (min-width: 750px) 50vw, 100vw');
    }
  }

  function onSwatchClick(event) {
    const swatch = event.target.closest('.collection__pgf-grid .color-swatch');
    if (!swatch) return;

    const blockId = swatch.getAttribute('data-block-id');
    const variantId = swatch.getAttribute('data-variant-id');
    const root = swatch.closest('.collection__pgf-grid');
    if (!root || !blockId) return;

    root.querySelectorAll('.color-swatch[data-block-id="' + blockId + '"]').forEach(function (s) {
      s.classList.remove('active');
    });
    swatch.classList.add('active');

    if (variantId) {
      const variantImage = swatch.getAttribute('data-variant-image');
      updateProductImages(blockId, variantId, swatch, variantImage);
    }
  }

  function init() {
    document.querySelectorAll('.collection__pgf-grid.product-card-featured-grid').forEach(bindGalleryHovers);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('collection:reloaded', init);
  document.addEventListener('click', onSwatchClick);
})();
